// extracted by css-extract-rspack-plugin
export default {"container":"GvaQ4HxysT0WDe6L","text":"pvwLvc5VGUuNy2zd"};